<template>
  <main>
    <div class="banner-wrapper"  v-if="!marketingActive">
      <ag-state-banner
        :inactive-status="true"
        class="ag-state-banner--standalone"
      />
    </div>
    <section class="content-wrapper">
      <ag-header
        title="Redaktionsmarketing"
      />
      <div v-if="!marketingActive">
        <h3 class="content__headline">Zeigen Sie Ihre Kompetenz!</h3>
        <p>Verwandeln Sie gemeinsam mit unseren Redakteur*innen
          komplexe Themen in verständliche Fachartikel.
        </p>
        <p class="content__text">
          Durch unsere SEO-orientierte Herangehensweise können wir Sie optimal unterstützen –
          denn wir wissen, wonach die Nutzer suchen und ermöglichen Ihnen mit bestimmten Keywords
          potentielle Mandanten zu erreichen.
        </p>
        <h4 class="content__headline">Jetzt mehr über Redaktionsmarketing erfahren:</h4>
        <a
          class="button-link"
          href="https://www.advogarant.de/marketing/rechtsanwaelte/redaktionsmarketing/"
          target="_blank"
        >
          Für Rechtsanwälte
        </a>
        <a
          class="button-link"
          href="https://www.advogarant.de/marketing/steuerberater/redaktionsmarketing/"
          target="_blank"
        >
          Für Steuerberater
        </a>
        <a
          class="button-link"
          href="https://www.advogarant.de/marketing/sachverstaendige/redaktionsmarketing/"
          target="_blank"
        >
          Für Sachverständige
        </a>
      </div>
      <div v-if="marketingActive">
        <p>
          Mit dem Redaktionsmarketing nutzen Sie derzeit den wohl nachhaltigsten Weg,
          Mandanten auf sich und Ihre Kanzlei aufmerksam zu machen!
        </p>
        <p>
          Neben der Stärkung der Online-Reichweite und Ihrer Sichtbarkeit haben Sie die
          Möglichkeit, sich persönlich zu entfalten und zu präsentieren. Sprechen Sie uns an
          und wir besprechen gemeinsam Ihre Möglichkeiten, Ihre Kompetenzen adäquat einzusetzen
          und zu positionieren.
        </p>
        <p class="content__text">
          Wir unterstützen Sie gerne bei der <strong>Auswahl relevanter Themen</strong> aus
          Ihrem Fachbereich und bei der <strong>Optimierung Ihrer Texte</strong> für Leser und
          Suchmaschinen. Berichten Sie doch von einem ganz besonders interessanten Fall oder
          kommentieren Sie ein richtungsweisendes Urteil! Wir freuen uns auf Ihre Nachricht.
        </p>
        <ag-header
          title="Meine Statistiken"
        />
        <p class="content__text" v-if="contentList.length > 0">
          Finden Sie heraus wie Ihre Artikel ankommen.
          Klicken Sie auf einen Ihrer Artikel um sich die jeweilige Statistik anzusehen.
        </p>
        <div class="marketing-statistics" v-if="contentList.length > 0">
          <ag-pagination
            v-if="parseInt(pageCount, 10) > 1"
            :page-count="pageCount"
            :current-page="currentPage"
          />
          <ul class="marketing-statistics__list">
            <li
              class="marketing-statistics__list-item"
              v-for="statistic in contentList"
              :key="`statistic-${statistic.contentId}`"
            >
              <div class="marketing-statistics__item-headline">
                {{ statistic.contentHeadline }}
              </div>
              <div class="marketing-statistics__item-date">
                {{ formatDate(statistic.modificationDate) }}
              </div>
              <div class="marketing-statistics__item-stats">
                <div
                  v-if="parseInt(statistic.readers) > 0"
                  class="marketing-statistics__article-stat"
                >
                  <ag-icon
                    class="marketing-statistics__stat-icon"
                    name="marketing-readers"
                  />
                  <div class="marketing-statistics__stat-label">
                    Leser
                  </div>
                  <div class="marketing-statistics__stat-rating">
                    {{ statistic.readers }}
                  </div>
                </div>
                <div
                  v-if="parseInt(statistic.readers) > 0"
                  class="marketing-statistics__article-stat">
                  <ag-icon
                    class="marketing-statistics__stat-icon"
                    name="marketing-reach"
                  />
                  <div class="marketing-statistics__stat-label">
                    Reichweite
                  </div>
                  <div class="marketing-statistics__stat-rating">
                    {{ statistic.reach }}
                  </div>
                </div>
                <div
                  v-if="parseInt(statistic.readers) > 0"
                  class="marketing-statistics__article-stat"
                >
                  <ag-icon
                    class="marketing-statistics__stat-icon"
                    name="marketing-growth"
                  />
                  <div class="marketing-statistics__stat-label">
                    Wachstum
                  </div>
                  <div class="marketing-statistics__stat-rating">
                    <ag-icon
                      v-if="parseInt(statistic.growth, 10) < 0"
                      class="marketing-statistics__low-icon"
                      name="marketing-arrow-down"
                    />
                    <ag-icon
                      v-if="parseInt(statistic.growth, 10) === 0"
                      class="marketing-statistics__stagnation-icon"
                      name="marketing-stagnation"
                    />
                    <ag-icon
                      v-if="parseInt(statistic.growth, 10) > 0"
                      class="marketing-statistics__up-icon"
                      name="marketing-arrow-down"
                    />
                  </div>
                </div>
              </div>
              <div class="marketing-statistics__item-links">
                <a class="marketing-statistics__item-link" :href="statistic.link" target="_blank">
                  Zum Artikel
                </a>
                <router-link
                  target="_blank"
                  class="marketing-statistics__item-route"
                  :to="{ name: 'marketing.statistic', params: { id: statistic.contentId }}">
                  <ag-icon name="arrow-right" />
                </router-link>
              </div>
            </li>
          </ul>
          <ag-pagination
            v-if="parseInt(pageCount, 10) > 1"
            :page-count="pageCount"
            :current-page="currentPage"
          />
        </div>
        <p class="content__text" v-else>
          Wir haben noch keinen redaktionellen Beitrag von Ihnen erhalten. Beginnen Sie noch
          heute Ihren Weg zu mehr Reichweite und schicken Sie Ihren ersten Beitrag gleich
          an <a href="mailto:redaktion@advogarant.de">redaktion@advogarant.de</a>
        </p>
      </div>
      <ag-info-box v-if="!marketingActive" :isMarketing="true" />
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import AgStateBanner from '@/components/shared/AgStateBanner.vue';
import AgInfoBox from '@/components/shared/AgInfoBox.vue';
import AgIcon from '@/components/shared/AgIcon.vue';
import AgPagination from '@/components/shared/AgPagination.vue';
import { mapState } from 'vuex';

export default {
  name: 'marketing',
  components: {
    AgHeader,
    AgStateBanner,
    AgInfoBox,
    AgPagination,
    AgIcon,
  },
  metaInfo: {
    title: 'Redaktionsmarketing',
  },
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      unwatchCustomerId: null,
      pageCount: 0,
      currentPage: 1,
      pageSize: 10,
      contentList: [],
      apiUrl: process.env.VUE_APP_API_ENDPOINT,
    };
  },
  computed: {
    ...mapState({
      customerId: (state) => state.user.customerId,
    }),
    marketingActive() {
      return this.activeServices.find((service) => service.key === 'editorial-marketing');
    },
  },
  mounted() {
    if (this.marketingActive) {
      this.currentPage = parseInt(this.$route.query.page || 1, 10);
      if (this.customerId) {
        this.loadListData();
      } else {
        this.unwatchCustomerId = this.$watch('customerId', (newVal, oldVal) => {
          if (newVal !== oldVal) {
            this.loadListData();
          }
          this.unwatchCustomerId();
        });
      }
    }
  },
  destroy() {
    if (this.unwatchCustomerId) {
      this.unwatchCustomerId();
    }
  },
  methods: {
    loadListData() {
      this.axios.get(
        `${this.apiUrl}/customer/${this.customerId}/ag-content/`, {
          params: {
            page: this.currentPage,
            'page-size': this.pageSize,
          },
        },
      )
        .then(({ headers, data }) => {
          // this.metaInfo.title = `Redaktionsstatistik Seite ${this.currentPage}`;
          this.pageSize = parseInt(headers['x-page-size'], 10);
          this.totalAmount = parseInt(headers['x-total-amount'], 10);
          this.pageCount = parseInt(headers['x-page-count'], 10);
          this.contentList = data;
        })
        .catch((err) => {
          console.log('Ein Fehler ist passiert', err);
        });
    },
    formatDate(date) {
      const d = new Date(date);
      const year = `${d.getFullYear()}`;
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;

      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }

      return [day, month, year].join('.');
    },
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page || 1, 10);
      this.loadListData();
    },
  },
};
</script>

<style lang="scss">

.marketing-statistics {

  &__list {
    padding: 0;
    list-style: none;
  }

  &__list-item {
    border: 2px solid #D7DDE5;
    padding: rem(12px) rem(15px);
    margin-bottom: rem(10px);
    min-height: rem(120px);
    background-color: #fff;
    box-shadow: 0 0 10px rgba(17, 42, 122, 0.161);
    position: relative;
  }

  &__item-headline {
    font-size: rem(15px);
    color: $primary-color;
    margin-bottom: rem(20px);
    margin-right: rem(75px);
    font-weight: 600;

    @include mq($mq-medium) {
      font-size: rem(16px);
    }
  }

  &__item-date {
    font-size: rem(13px);
    position: absolute;
    top: rem(12px);
    right: rem(15px);

    @include mq($mq-medium) {
      font-size: rem(15px);
    }
  }

  &__item-stats {
    display: flex;
    flex-wrap: wrap;

    @include mq($mq-medium) {
    }
  }

  &__article-stat {
    height: rem(19px);
    position: relative;
    margin-bottom: rem(15px);
    display: flex;
    align-items: center;
    margin-right: rem(30px);

    @include mq($mq-medium) {
      display: block;
      height: rem(43px);
      padding-left: rem(52px);
      margin-right: rem(50px);
    }
  }

  &__stat-icon {
    width: rem(19px);
    height: rem(19px);
    margin-right: rem(8px);

    @include mq($mq-medium) {
      margin-right: 0;
      position: absolute;
      left: 0;
      width: rem(43px);
      height: rem(43px);
    }
  }

  &__stat-label {
    font-size: rem(14px);
    height: rem(19px);
    font-weight: 700;
    color: #67696C;
    margin-right: rem(5px);
  }

  &__stat-rating {
    font-weight: 700;

    @include mq($mq-medium) {
      font-size: rem(20px);
    }
  }

  &__low-icon {
    height: rem(15px);
    width: rem(15px);
    color: #BB4C4C;
    transform: rotate(180deg);
  }

  &__stagnation-icon {
    height: auto;
    width: rem(15px);

    @include mq($mq-medium) {
      height: rem(15px);
    }
  }

  &__up-icon {
    height: rem(15px);
    width: rem(15px);
    color: #198846;
  }

  &__item-links {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @include mq($mq-large) {
      position: absolute;
      bottom: rem(27px);
      right: rem(15px);
    }
  }

  &__item-link {
    font-size: rem(13px);
    margin-right: rem(20px);
    text-decoration-line: underline;
    font-weight: 600;

    @include mq($mq-medium) {
      margin-right: rem(50px);
    }

    &:active,
    &:visited {
      color: #3169AA;
    }
  }

  &__item-route {
    width: em(40px);
    height: em(40px);
    flex-shrink: 0;
    border-radius: 50%;
    background-color: #3169AA;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active,
    &:visited {
      color: #fff;
    }
  }
}

</style>
